import { Button, Classes, Dialog, FileInput, FormGroup, HTMLTable, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IProduto } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { ProdutoStore } from "../../stores/legislacao/ProdutoStore";
import { Pager } from "../utils/Pager";
import { ProdutoDialog } from "./ProdutoDialog";
import { ProdutoDialogCreate } from "./ProdutoDialogCreate";
import moment from "moment";
var debounce = require('lodash.debounce');

interface ProdutosPageProps {
  estado: string;
}

interface ProdutosPageState { }

@observer
export class ProdutosPage extends React.Component<ProdutosPageProps, ProdutosPageState> {

  obs = observable({
    create: false as boolean,
    viewing: null as IProduto,
    currentPage: 1 as number,
    loading_export: false as boolean,
    loading_import: false as boolean,
    open_import_produtos: false as boolean,
    file_name: "Selecione um arquivo XLSX" as string,
    fetchOptions: {} as any
  })

  constructor(props: ProdutosPageProps) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleFilter.bind(this), 800);

  }

  async componentDidMount() {

    AppStore.setTitle("Produtos");

    await ProdutoStore.loadProdutos(1, "", "entrada", this.props.estado);

  }

  handleFilter = async () => {

    await ProdutoStore.loadProdutos(1, ProdutoStore.obs.filter, ProdutoStore.obs.selectedTab,this.props.estado)

  };

  handleSetFilter = async (e: any) => {

    ProdutoStore.obs.filter = e.target.value

    this.obs.currentPage = 1;

    this.obs.fetchOptions()

  };

  handleView(produto: IProduto) {
    
    produto.valido_de = produto.valido_de ? moment(produto.valido_de).add(3, "hours").toDate() : null
    produto.valido_ate = produto.valido_ate ? moment(produto.valido_ate).add(3, "hours").toDate() : null

    this.obs.viewing = produto;
  }

  handleCreate = () => {
    this.obs.create = true
  }

  async handleDelete(produto) {

    if (window.confirm(`Excluir produto ${produto.descricao}`)) {

      produto.estado  = this.props.estado

      let res = await ProdutoStore.handleDelete(produto)

      if (res) {

        this.obs.currentPage = 1;

        await ProdutoStore.loadProdutos(1, ProdutoStore.obs.filter, ProdutoStore.obs.selectedTab, this.props.estado)

      }

    }

  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  handleAdd = () => {

    this.obs.viewing = {
      descricao: "Novo produto",
      cest: "X",
      ncm: "",
      aliquota_interna: 17,
      aliquota_interna_regime: null,
      entrada: true,
      estado: this.props.estado,
      valido_de: null,
      valido_ate: null
    };

  };

  async handleExport() {
    this.obs.loading_export = true

    await ProdutoStore.handleExport(ProdutoStore.obs.selectedTab, this.props.estado)

    this.obs.loading_export = false
  }

  handleImport() {

    this.obs.open_import_produtos = true;

  };

  handleFileInputChange = async (event) => {

    this.obs.loading_import = true;

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();
    data.append("file", file);
    data.append("entrada", ProdutoStore.obs.selectedTab == "entrada" ? "true" : "false");
    data.append("estado", this.props.estado);

    let res = await ProdutoStore.handleImport(data)

    if (res) {

      this.obs.currentPage = 1;

      await ProdutoStore.loadProdutos(1, ProdutoStore.obs.filter, ProdutoStore.obs.selectedTab, this.props.estado)

      this.obs.open_import_produtos = false;

      this.obs.file_name = "Selecione um arquivo CSV"

    }

    this.obs.loading_import = false;

  };

  validadeFormatter(d) {
      return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;
    }

  async handleChangeTab(tabId) {

    ProdutoStore.obs.selectedTab = tabId

    await ProdutoStore.loadProdutos(1, ProdutoStore.obs.filter, tabId, this.props.estado)

  }

  async handleChangePage(page) {

    this.obs.currentPage = page;

    await ProdutoStore.loadProdutos(page, ProdutoStore.obs.filter, ProdutoStore.obs.selectedTab, this.props.estado)

  }

  render() {

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    let items = ProdutoStore.obs.produtos?.map(produto => {
      return (
        <tr key={produto.id}>
          <td>{produto.cest}</td>
          <td>{produto.ncm}</td>
          <td>{produto.descricao}</td>
          <td>{this.validadeFormatter(produto.valido_de)}</td>
          <td>{this.validadeFormatter(produto.valido_ate)}</td>
          {user_admin &&
            <td className="nz-table-actions">
              <MDBBtn
                color="default"
                rounded
                size="sm"
                onClick={this.handleView.bind(this, produto)}
              >
                <img src="/images/edit.png" width={25} />
              </MDBBtn>
              <MDBBtn
                color="default"
                rounded
                size="sm"
                onClick={this.handleDelete.bind(this, produto)}
              >
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
            </td>
          }
        </tr>
      );
    });

    return (
      <div>
        <MDBRow>
          <MDBCol md="12">

            {user_admin &&
              <MDBBtn className="btnDefault noFloat" onClick={this.handleCreate} style={{ marginRight: 10 }}>
                Novo produto
              </MDBBtn>
            }

            <Button
              icon="export"
              className="btnRoxo"
              onClick={() => this.handleExport()}
              loading={this.obs.loading_export}
              style={{ marginRight: 10 }}
            >
              Exportar
            </Button>

            {user_admin &&
              <Button
                icon="import"
                className="btnRoxo"
                onClick={() => this.handleImport()}
                loading={this.obs.loading_import}
              >
                Importar
              </Button>
            }

          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="6" className="inputFilter">
            <InputGroup
              round
              leftIcon="search"
              style={{ width: 400, borderRadius: 10 }}
              placeholder="Filtrar..."
              value={ProdutoStore.obs.filter}
              onChange={(e) => this.handleSetFilter(e)}
            />
          </MDBCol>
        </MDBRow>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={ProdutoStore.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(String(tabId))}
        >

          <Tab
            id="entrada"
            title="Entrada"
            panel={<></>} />

          <Tab
            id="saida"
            title="Saída"
            panel={<></>} />

        </Tabs>

        <div className="TableDefault">

          <HTMLTable
            className="table table-hover dataTable"
            style={{ width: "100%", marginTop: 15 }}
            small
          >
            <thead>
              <tr>
                <th style={{ width: 120 }}>CEST</th>
                <th style={{ width: 120 }}>NCM</th>
                <th>Descrição</th>
                <th style={{ width: 150 }}>Valido de</th>
                <th style={{ width: 150 }}>Valido até</th>
                {user_admin && <th style={{ width: 150 }} />}
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </HTMLTable>

        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>

          <Pager
            currentPage={this.obs.currentPage}
            totalCount={ProdutoStore.obs.produtos_length}
            pageSize={50}
            onPageChange={page => this.handleChangePage(page)}
          />

        </div>

        <Dialog
          isOpen={this.obs.open_import_produtos}
          title={"Importar Produtos - " + ProdutoStore.obs.selectedTab.toUpperCase()}
        >
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>

              <b>Observação:</b> Ao importar o arquivo, todos os produtos cadastrados no sistema serão substituídos pelos produtos presentes no arquivo, conforme o tipo selecionado na aba. <br />

            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_import_produtos = false} />
            </div>
          </div>

        </Dialog>

        {this.obs.viewing && (<ProdutoDialog estado={this.props.estado} produto={this.obs.viewing} onClose={this.handleViewClose} />)}
        {this.obs.create && (<ProdutoDialogCreate estado={this.props.estado} onClose={() => this.obs.create = false} />)}

      </div>
    );
  }
}

export default ProdutosPage;
